// ProtectedRoute.js
import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import { useAuth } from './authContext';

const ProtectedRoute = ({ element, ...props }) => {
  const { isAuthenticated } = useAuth();

  return isAuthenticated ? (
    React.cloneElement(element, props)
  ) : (
    <Navigate to="/login" replace />
  );
};

export default ProtectedRoute;
